<template>
    <div class="viewAllProgress">
    <table border class="timeline-table">
        <thead>
        <tr>
            <th v-for="item in tableHeader">
                {{item}}
            </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in timelineList" :key="item.czId">
            <td v-for="item1 in item">
                <component v-if="item1" :is="item1.componentName" :timeLineList="item1"></component>
            </td>
        </tr>

        </tbody>
    </table>
    </div>
</template>

<script>
    import { onMounted, ref, inject, getCurrentInstance} from 'vue';
    import {timeLineToComponent} from '../../../assets/js/base.js';
    import TimeLine_JGSH from '@/components/timeLine/TimeLine_JGSH.vue';
    import TimeLine_JPDW from '@/components/timeLine/TimeLine_JPDW.vue';
    import TimeLine_GDFP from '@/components/timeLine/TimeLine_GDFP.vue';
    import TimeLine_GDCZ from '@/components/timeLine/TimeLine_GDCZ.vue';
    import TimeLine_DBCC from '@/components/timeLine/TimeLine_DBCC.vue';
    import TimeLine_THSH from '@/components/timeLine/TimeLine_THSH.vue';
    import TimeLine_GDQS from '@/components/timeLine/TimeLine_GDQS.vue';
    import TimeLine_GDTH from '@/components/timeLine/TimeLine_GDTH.vue';
    import TimeLine_GDDB from '@/components/timeLine/TimeLine_GDDB.vue';
    import TimeLine_CJGD from '@/components/timeLine/TimeLine_CJGD.vue';
    import TimeLine_GDGP from '@/components/timeLine/TimeLine_GDGP.vue';
    import TimeLine_GDTS from '@/components/timeLine/TimeLine_GDTS.vue';
    import TimeLine_GDGD from '@/components/timeLine/TimeLine_GDGD.vue';

    export default {
        name: "TimelineAll",
        components: {
            TimeLine_GDFP,
            TimeLine_JGSH,
            TimeLine_JPDW,
            TimeLine_GDCZ,
            TimeLine_DBCC,
            TimeLine_THSH,
            TimeLine_GDQS,
            TimeLine_GDTH,
            TimeLine_GDDB,
            TimeLine_CJGD,
            TimeLine_GDGP,
            TimeLine_GDTS,
            TimeLine_GDGD
        },
        props: ["parentToChild"],
        setup(props, context) {
            const {proxy} = getCurrentInstance();
            let timelineList = ref();
            const tableHeader = ref()
            onMounted(() => {
                timeLine();
            });

            function timeLine() {
                proxy.$axios.post("/jgfast/wgsj/selCzlcmkt", {
                    "gdId": props.parentToChild.gdId
                }).then((res) => {
                    if (res.data) {
                        tableHeader.value = res.data.header;
                        res.data.list.map((item) => {
                            item.map((x) => {
                                if (x && x.czCzlx) {
                                    return x.componentName = timeLineToComponent[x.czCzlx]
                                }
                            })
                        })
                        timelineList.value = res.data.list;
                    } else {
                        timelineList.value = []
                    }
                });
            }

            return {
                timelineList,
                timeLine,
                tableHeader
            }
        }
    }
</script>

<style scoped lang="less">
    .viewAllProgress{
        padding:12px;
        min-width: 100%;
        display: inline-block;
    }
    .timeline-table {
        min-width: 100%;
        border-color:#DDE0F1;
        background-color: white;
        thead {
            background-color: #D1DBFE;
            color: #1B4CFB;
            font-family: 'Microsoft YaHei UI';
            font-style: normal;
            font-weight: 700;
            font-size: 14px;
            tr {
                height: 40px;
            }
            th{
                min-width: 520px;
            }
        }
    }

</style>
